import {useState, useEffect} from 'react';
import {APIv1} from '../../api';
import useUserMaskStore from '../../store/user/userMaskStore';

const useUserToken = (userToken) => {
    const [token, setToken] = useState(null);
    const maskedCompany = useUserMaskStore((state) => state.maskedCompany);

    useEffect(() => {
        const fetchToken = async () => {
            if (!userToken) return;

            try {
                if (maskedCompany) {
                    const response = await APIv1.get(`user/get/token/${maskedCompany.inn}/`, {
                        headers: {Authorization: `Token ${userToken}`},
                    });
                    const newToken = response.data.token;
                    setToken(newToken);
                } else {
                    setToken(userToken);
                }
            } catch (error) {
                console.error('Error fetching token:', error);
            }
        };

        fetchToken();
    }, [userToken, maskedCompany]);

    return token;
};

export default useUserToken;